import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { SnackbarProvider } from "notistack";
import { ThemeProviderWraper } from "./theme/providers/ThemeProvider";
import { RTLProvider } from "./theme/providers/RTLProvider";
import "./I18n";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    {/* <React.StrictMode> */}
    <Suspense fallback="Loading">
      <RTLProvider>
        <ThemeProviderWraper>
          <SnackbarProvider>
            <ToastContainer />

            <App />
          </SnackbarProvider>
        </ThemeProviderWraper>
      </RTLProvider>
    </Suspense>
    {/* </React.StrictMode> */}
  </BrowserRouter>
);

reportWebVitals();
